<!-- <p>offline-pop-up works!</p> -->
<div class="wrapper">
    <div class="header">
        Confirmation Dialog !!
    </div>
    <div class="content-wrapper">
        <div class="text1">
            You have unprocessed Records!! Would you like to process them first!
        </div>
        <div class="footer_div" >
            <div class="footer_button">
                <ls-button (click)="confirm()">Confirm</ls-button>
            </div>
            <div class="footer_button">
                <ls-button (click)="quit()">Quit</ls-button>
            </div>
           
        </div>
    </div>
</div>